import { render } from "./App.vue?vue&type=template&id=1279dd4d&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=1279dd4d&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/mysystem_data_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__